import { EtiquettePerso } from './Etiquette';
import { User } from '../../model';

export class EtiquetteFavoris {
    id: number;
    etiquettePersoFavorisId: number;
    etiquetteBaseFavorisId: number;
    userId: number;
}
